import { Model } from 'modules/core/lib/mobx-rest'

import { PolicyTarget } from 'modules/permissions/store/collections/policyAuthorizations'

interface IUnassignedShift {
  id: number | null
  start_at: string
  end_at: string
  location_id: number | null
  work_area_id: number | null
  notes: string | null
  extra_hours: boolean | null
  color: string | null
  counter: number
  job_catalog_roles_ids: number[]
  job_catalog_tree_role_uuids: string[]
  overnight_shift: boolean
  default_shift_id: number | null
  default_shift_title: string | null
  all_company: boolean | null
  teams_ids_visibilities: number[] | null
  locations_ids_visibilities: number[] | null
}

class UnassignedShift extends Model<IUnassignedShift> implements PolicyTarget {
  static urlRoot() {
    return '/shift_management/unassigned_shifts'
  }

  get policyTargetClass(): string {
    return '::ShiftManagement::UnassignedShift'
  }
}

export default UnassignedShift
